import MataUjiService from "../../services/sertifikasi/mata-uji.service";

export const MataUji = {
    data() {
      return {
        loadingMultiSelect : {
          isLoadingMataUji : true
        },
        loading: true,
        optionMasterMataUji : [],
        multi_master_mata_uji : [],
        items_master_mata_uji : [],
      };
    },
    methods: {
      getAllMataUji() {
        this.loading = true;
        MataUjiService.getAllMataUji()
          .then(response => {
              this.optionMasterMataUji = response.data.data.content
              this.items_master_mata_uji = response.data.data.content 
              this.loadingMultiSelect.isLoadingMataUji = false;
              this.loading = false;
          }).catch(error => {
              // comment console console.log(error)
              this.loading = false;
          })
      }
    }
  };